import React from "react";

import { Moment } from "moment";

import { AllAvailableViews } from "@mui/lab/internal/pickers/typings/Views";

import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";

function DateTimePickerToolbar({
    date,
    setOpenView,
    openView,
    toolbarTitle,
    views,
}: {
    date: Moment | null;
    setOpenView: (view: AllAvailableViews) => void;
    openView: AllAvailableViews;
    toolbarTitle?: React.ReactNode;
    views: readonly AllAvailableViews[];
}) {
    const primaryTextColor = "rgba(0,0,0,0.87)";
    const secondaryTextColor = "rgba(0,0,0,0.6)";

    return (
        <div style={{ padding: "16px 24px", paddingBottom: "5px" }}>
            <div>
                <Typography color={"text.secondary"} variant={"overline"}>
                    {toolbarTitle}
                </Typography>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                }}
            >
                {views.includes("year") && views.includes("day") && (
                    <div style={{ display: "flex", flexDirection: "column", marginRight: "2rem" }}>
                        <div>
                            <ButtonBase
                                data-testid={"open-view-day"}
                                onClick={() => setOpenView("day")}
                            >
                                <Typography
                                    component={"span"}
                                    variant={"h4"}
                                    color={
                                        openView === "day" ? primaryTextColor : secondaryTextColor
                                    }
                                >
                                    {date ? date.format("DD MMMM") : "-"}
                                </Typography>
                            </ButtonBase>
                        </div>
                        <div>
                            <ButtonBase
                                data-testid={"open-view-year"}
                                onClick={() => setOpenView("year")}
                            >
                                <Typography
                                    component={"span"}
                                    variant={"h5"}
                                    color={
                                        openView === "year" ? primaryTextColor : secondaryTextColor
                                    }
                                >
                                    {date ? date.format("YYYY") : "-"}
                                </Typography>
                            </ButtonBase>
                        </div>
                    </div>
                )}

                {views.includes("hours") && views.includes("minutes") && (
                    <div style={{ display: "flex" }}>
                        <ButtonBase
                            data-testid={"open-view-hours"}
                            onClick={() => setOpenView("hours")}
                        >
                            <Typography
                                component={"span"}
                                variant={"h3"}
                                color={openView === "hours" ? primaryTextColor : secondaryTextColor}
                            >
                                {date ? date.format("HH") : "-"}
                            </Typography>
                        </ButtonBase>
                        <Typography
                            component={"span"}
                            variant={"h3"}
                            style={{ margin: "0 4px 0 6px" }}
                            color={secondaryTextColor}
                        >
                            {":"}
                        </Typography>
                        <ButtonBase
                            data-testid={"open-view-minutes"}
                            onClick={() => setOpenView("minutes")}
                        >
                            <Typography
                                component={"span"}
                                variant={"h3"}
                                color={
                                    openView === "minutes" ? primaryTextColor : secondaryTextColor
                                }
                            >
                                {date ? date.format("mm") : "-"}
                            </Typography>
                        </ButtonBase>
                    </div>
                )}
            </div>
        </div>
    );
}

export default DateTimePickerToolbar;
